<template>
  <!-- bocna kolona ostalih stranica: svi oglasi koje stranica prosledi -->
  <AdsBlock
    :items="items"
    title="oglasi | pijace"
    dropdown="subcategory"
    dropdown-label="Potkategorije"
  />
</template>

<script setup>
import AdsBlock from '~/components/widgets/Advertisement/AdsBlock.vue'

defineProps({
  items: { type: Array, default: () => [] }
})
</script>
